import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';

import { ubicationTypeEnum } from '../../../utils/dataStatus';

const FinishedServiceModal = ({
  showFinishedServiceModal,
  setShowFinishedServiceModal,
  handleEndService,
  ubicationData
}) => {
  const onClickEndService = () => {
    handleEndService(ubicationData?.id);
    setShowFinishedServiceModal(false);
  };

  const modalMessageDescription = () => {
    const name = ubicationData?.nombre;
    const description = '¿ Estas seguro que desear finalizar el servicio para';

    switch (ubicationData?.tipoUbicacionEnum) {
      case ubicationTypeEnum.locacion:
        return `${description} la locacion ${name} ?`;
      case ubicationTypeEnum.pozo:
        return `${description} el pozo ${name} ?`;
      default:
        return `${description} la Ubicacion ${name} ?`;
    }
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={() => setShowFinishedServiceModal(false)}
      primaryAction={onClickEndService}
      primaryActionLabel="Si, Finalizar"
      secondaryAction={() => setShowFinishedServiceModal(false)}
      secondaryActionLabel="Salir"
      show={showFinishedServiceModal}
      size="md"
      title="Finalizar Solicitud"
    >
      <div className="modal_body_error">
        <p>{modalMessageDescription()}</p>
        {ubicationData?.isFinishedServiceUsable?.detalleLocacion?.descripcionPozos?.length && (
          <p>
            Pozos configurados:
            <span>
              {ubicationData?.isFinishedServiceUsable?.detalleLocacion?.descripcionPozos.join(
                ' | '
              )}
            </span>
          </p>
        )}
      </div>
    </ModalGeneric>
  );
};

FinishedServiceModal.propTypes = {
  showFinishedServiceModal: PropTypes.bool,
  setShowFinishedServiceModal: PropTypes.func.isRequired,
  handleEndService: PropTypes.func.isRequired,
  ubicationData: PropTypes.shape({
    id: PropTypes.number,
    nombre: PropTypes.string,
    tipoUbicacionEnum: PropTypes.number,
    isFinishedServiceUsable: PropTypes.shape({
      detalleLocacion: PropTypes.shape({
        descripcionPozos: PropTypes.arrayOf(PropTypes.string)
      })
    })
  })
};

FinishedServiceModal.defaultProps = {
  showFinishedServiceModal: false,
  ubicationData: PropTypes.shape({})
};

export default FinishedServiceModal;
